"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asset_accessor_1 = require("./asset-accessor");

var NullAccessor =
/** @class */
function () {
  function NullAccessor() {}

  NullAccessor.prototype.raw = function () {
    return undefined;
  };

  NullAccessor.prototype.field = function (name) {
    return new NullAccessor();
  };

  NullAccessor.prototype.array = function (name) {
    return [];
  };

  NullAccessor.prototype.text = function (name, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.longText = function (name, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.richText = function (name, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.slug = function (name, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.number = function (name, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype["boolean"] = function (name, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.asset = function (name) {
    return new asset_accessor_1.NullAssetAccessor();
  };

  NullAccessor.prototype.type = function () {
    return 'null';
  };

  NullAccessor.prototype.file = function (name) {
    return new asset_accessor_1.NullFileAccessor();
  };

  return NullAccessor;
}();

exports.NullAccessor = NullAccessor;